import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./instruction.scss";
import {Section1} from "./section1/section1";
import {Description} from "./description/description";

export const Instruction = ({}) => cs(
    () => (
        <div className="instruction instruction-9ya">
            <div className="title" xd-qa-type="label" xd-qa-name="Upload Address List Help & Support">
                Help & Support
            </div>

            <div className="content">
                {Section1({})}

                <div className="section2">
                    {[
                        {
                            title: "List hosting",
                            text: (
                                "As part of our service, we host your active mailing lists at no charge. In the event " +
                                "a list is not used for a period of eighteen (18) consecutive months, it will " +
                                "automatically be archived, and no longer available to you from your account. " +
                                "Please note: all mailing lists unused for twenty-four (24) consecutive months will " +
                                "be permanently deleted from our system."
                            ),
                        },

                        {
                            title: "Note",
                            text: (
                                "When uploading addresses with Zip Codes beginning with zero, the zero may be dropped " +
                                "from the address for storage in our site; however the addresses will print correctly " +
                                "and this will not affect delivery of mailers to these locations."
                            ),
                        },

                    ].map(({title, text}, i) => (
                        <div className="block" key={i}>
                            <div className="title" xd-qa-type="label" xd-qa-name={"Upload Address List "+title}>
                                {title}
                            </div>
                            {Description({
                                text,
                                xdQaName: "Upload Address List "+title,
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ),
);
